const locomotiveScroll = new LocomotiveScroll();

// product inner tabs
if (document.querySelector("[data-gallery-tabs]")) {
  new Tabby("[data-gallery-tabs]");
}


// Robust close for all modals (login / signup / forgot password) — delegated,
// so it works even for modals injected at runtime whose close control isn't
// wired to MicroModal, and regardless of the modal's exact wrapper markup.
function acHideModal(root, forceDisplayNone) {
  if (!root) return;
  root.classList.remove("is-open");
  root.setAttribute("aria-hidden", "true");
  // only the generic path needs inline display:none; .ac-login is hidden by CSS
  if (forceDisplayNone) root.style.display = "none";
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
}

document.addEventListener("click", function (e) {
  var closer = e.target.closest("[data-micromodal-close]");
  if (!closer) return;

  // if the closer is an overlay, ignore clicks that bubbled up from the dialog
  if (
    (closer.classList.contains("ac-login__overlay") ||
      closer.classList.contains("modal__overlay")) &&
    e.target.closest(".ac-login__box, .modal__container, [role='dialog']")
  ) {
    return;
  }

  // 1) known .ac-login modal → close via MicroModal when possible
  var modal = closer.closest(".ac-login");
  if (modal) {
    var closed = false;
    if (window.MicroModal && modal.id) {
      try {
        MicroModal.close(modal.id);
        closed = true;
      } catch (err) {
        closed = false;
      }
    }
    if (!closed) acHideModal(modal, false);
    return;
  }

  // 2) any other structure → hide the nearest full-screen (fixed) container
  var el = closer.parentElement;
  while (el && el !== document.body) {
    if (window.getComputedStyle(el).position === "fixed") {
      acHideModal(el, true);
      return;
    }
    el = el.parentElement;
  }
});

// hero splide code
document.addEventListener("DOMContentLoaded", function () {
  new Splide(".ac-hero-slider", {
    type: "loop",
    rewind: true,
    perPage: 1,
    arrows: false,
    pagination: true,
    autoplay: true,
    interval: 2600,
    pauseOnHover: true,
    speed: 400,
  }).mount();
});

// featured products slider (large image + product card)
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".ac-featureSlider__slider")) {
    new Splide(".ac-featureSlider__slider", {
      // type: "loop",
      perPage: 1,
      arrows: true,
      pagination: false,
      speed: 800,
      autoplay: true,
      interval: 3000,
      // pauseOnHover: true,
    }).mount();
  }
});

// product card slider (best seller / new arrivals share the same behaviour)
document.addEventListener("DOMContentLoaded", function () {
  function initProductSlider(sliderSelector, arrowSelector) {
    var el = document.querySelector(sliderSelector);
    if (!el) return;

    var slider = new Splide(sliderSelector, {
      perPage: 4,
      perMove: 1,
      gap: "24px",
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 2600,
      pauseOnHover: true,
      speed: 600,
      breakpoints: {
        1199: { perPage: 3 },
        1023: { perPage: 2, gap: "20px" },
        575: { perPage: 1, perMove: 1, gap: "16px" },
      },
    }).mount();

    var prevBtn = document.querySelector(arrowSelector + '[data-dir="prev"]');
    var nextBtn = document.querySelector(arrowSelector + '[data-dir="next"]');

    // dim the prev arrow on the first slide, next arrow on the last
    function updateArrows() {
      var end = slider.Components.Controller.getEnd();
      if (prevBtn) prevBtn.disabled = slider.index <= 0;
      if (nextBtn) nextBtn.disabled = slider.index >= end;
    }

    slider.on("mounted moved updated resized", updateArrows);

    if (prevBtn)
      prevBtn.addEventListener("click", function () {
        slider.go("<");
      });

    if (nextBtn)
      nextBtn.addEventListener("click", function () {
        slider.go(">");
      });
  }

  initProductSlider(".ac-bestSellerSlider", ".ac-bestSellerSec__arrow");
  initProductSlider(".ac-newArrSlider", ".ac-newArrSec__arrow");
});


document.addEventListener("DOMContentLoaded", function () {
  initProductSlider(".ac-newArrSlider", ".ac-newArrSec__arrow");
});



// header categories mega drawer
document.addEventListener("DOMContentLoaded", function () {
  var toggle = document.querySelector(".ac-header__catToggle");
  var drawer = document.getElementById("acCatDrawer");
  var overlay = document.querySelector(".ac-header__overlay");
  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    // next frame so the transition runs from the hidden state
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
    });
    toggle.setAttribute("aria-expanded", "true");
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    // wait for the transition before removing from the flow
    window.setTimeout(function () {
      if (toggle.getAttribute("aria-expanded") === "false") {
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
      }
    }, 300);
  }

  toggle.addEventListener("click", function () {
    if (toggle.getAttribute("aria-expanded") === "true") {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (overlay) overlay.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
      closeDrawer();
    }
  });

  // swap the active category / panel on hover + focus
  var catBtns = drawer.querySelectorAll(".ac-header__catBtn");
  var panels = drawer.querySelectorAll(".ac-header__catPanel");

  function activatePanel(name) {
    catBtns.forEach(function (btn) {
      btn.parentElement.classList.toggle(
        "ac-header__catItem--active",
        btn.dataset.panel === name,
      );
    });
    panels.forEach(function (panel) {
      panel.classList.toggle(
        "ac-header__catPanel--active",
        panel.dataset.panel === name,
      );
    });
  }

  catBtns.forEach(function (btn) {
    btn.addEventListener("mouseenter", function () {
      activatePanel(btn.dataset.panel);
    });
    btn.addEventListener("focus", function () {
      activatePanel(btn.dataset.panel);
    });
  });

  // Locomotive Scroll hijacks the wheel on the whole page, so the drawer's
  // own scroll areas never scroll natively. Drive them by hand and stop the
  // event from reaching Locomotive.

 var AC_SCROLL_AREAS =
  ".ac-login__box, .ac-login__overlay, .MuiDialogContent-root, .ac-cartDrawer__body, .ac-productList__sidebar";

document.addEventListener(
  "wheel",
  function (e) {
    var area = e.target.closest(AC_SCROLL_AREAS);
    if (!area) return;
    // nothing to scroll — let the event pass through
    if (area.scrollHeight <= area.clientHeight) return;
    area.scrollTop += e.deltaY;
    e.preventDefault();
    e.stopPropagation();
  },
  { passive: false },
);

document.addEventListener(
  "touchmove",
  function (e) {
    if (e.target.closest(AC_SCROLL_AREAS)) {
      e.stopPropagation();
    }
  },
  { passive: true },
);

  var scrollAreas = drawer.querySelectorAll(
    ".ac-header__catList, .ac-header__catPanels",
  );

  scrollAreas.forEach(function (area) {
    area.addEventListener(
      "wheel",
      function (e) {
        area.scrollTop += e.deltaY;
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false },
    );

    // touch devices: let the native overscroll handle the column
    area.addEventListener(
      "touchmove",
      function (e) {
        e.stopPropagation();
      },
      { passive: true },
    );
  });
});

// mobile / tablet off-canvas menu
document.addEventListener("DOMContentLoaded", function () {
  var burger = document.querySelector(".ac-header__burger");
  var menu = document.getElementById("acMobileMenu");
  if (!burger || !menu) return;

  function openMenu() {
    menu.hidden = false;
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () {
      menu.classList.add("is-open");
    });
    burger.setAttribute("aria-expanded", "true");
  }

  function closeMenu() {
    menu.classList.remove("is-open");
    document.body.style.overflow = "";
    burger.setAttribute("aria-expanded", "false");
    window.setTimeout(function () {
      if (!menu.classList.contains("is-open")) menu.hidden = true;
    }, 400);
  }

  burger.addEventListener("click", function () {
    if (burger.getAttribute("aria-expanded") === "true") {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // close via the X, the backdrop, or any link inside the menu
  menu.addEventListener("click", function (e) {
    if (e.target.closest("[data-mobile-close]") || e.target.closest("a")) {
      closeMenu();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && menu.classList.contains("is-open")) {
      closeMenu();
    }
  });

  // Locomotive Scroll hijacks the wheel, so the menu's own scroll area never
  // scrolls natively. Drive it by hand and stop the event bubbling out.
  var scrollArea = menu.querySelector(".ac-header__mobileNav");

  if (scrollArea) {
    scrollArea.addEventListener(
      "wheel",
      function (e) {
        scrollArea.scrollTop += e.deltaY;
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false },
    );

    scrollArea.addEventListener(
      "touchmove",
      function (e) {
        e.stopPropagation();
      },
      { passive: true },
    );
  }
});

// product card buttons: toggle a state (colour change) on click
// document.addEventListener("DOMContentLoaded", function () {
//   document.addEventListener("click", function (e) {
//     var cart = e.target.closest(".ac-card__cart");
//     if (cart) {
//       e.preventDefault();
//       cart.classList.toggle("is-added");
//       return;
//     }

//     var fav = e.target.closest(".ac-card__fav");
//     if (fav) {
//       fav.classList.toggle("is-active");
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const cart = e.target.closest(".ac-card__cart");

    if (cart) {
      if (cart.tagName === "A") {
        // e.preventDefault();
      }

      cart.classList.toggle("is-added");
    }

    const fav = e.target.closest(".ac-card__fav");

    if (fav) {
      fav.classList.toggle("is-active");
    }
  });
});

// cart drawer: open on "Add to Cart", close on X / overlay / Escape
document.addEventListener("DOMContentLoaded", function () {
  var drawer = document.getElementById("acCartDrawer");
  if (!drawer) return;

  var lastFocused = null;

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
    // next frame so the slide transition runs from the closed state
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
    });
    var closeBtn = drawer.querySelector("[data-cart-close]");
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    // wait for the transition before removing from the flow
    window.setTimeout(function () {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
    }, 400);
    if (lastFocused && typeof lastFocused.focus === "function") {
      lastFocused.focus();
    }
  }

  // open from any "Add to Cart" trigger
  document.addEventListener("click", function (e) {
    if (e.target.closest(".ac-productInner__cart")) {
      e.preventDefault();
      openDrawer();
    }
  });

  // close via the X button or the backdrop
  drawer.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-close]")) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  // Locomotive Scroll hijacks the wheel on the whole page, so the drawer's
  // item list never scrolls natively. Drive it by hand and stop the event
  // from reaching Locomotive.
  var scrollArea = drawer.querySelector(".ac-cartDrawer__body");

  if (scrollArea) {
    scrollArea.addEventListener(
      "wheel",
      function (e) {
        scrollArea.scrollTop += e.deltaY;
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false },
    );

    // touch devices: let the native overscroll handle the column
    scrollArea.addEventListener(
      "touchmove",
      function (e) {
        e.stopPropagation();
      },
      { passive: true },
    );
  }
});

// quantity steppers (product page + cart drawer share the same markup)
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".ac-qty__btn[data-step]");
    if (!btn) return;

    var qty = btn.closest(".ac-qty");
    var input = qty && qty.querySelector(".ac-qty__input");
    if (!input) return;

    var step = parseInt(btn.dataset.step, 10) || 0;
    var value = (parseInt(input.value, 10) || 1) + step;
    if (value < 1) value = 1;
    input.value = value;
  });
});

// product list code
document.addEventListener("DOMContentLoaded", function () {
  var list = document.querySelector(".ac-productList");
  if (!list) return;

  var sidebar = document.querySelector(".ac-productList__sidebar");
  var filterToggle = document.querySelector(".ac-productList__filterToggle");

  // Use ONE source of truth: is-filterOpen on `list`.
  // Sync the sidebar's is-open to match it, so the hardcoded
  // is-open in the HTML doesn't cause an inverted first click.
  function setFilters(open) {
    list.classList.toggle("is-filterOpen", open);
    if (sidebar) sidebar.classList.toggle("is-open", open);
    if (filterToggle) filterToggle.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function openFilters()  { setFilters(true);  }
  function closeFilters() { setFilters(false); }

  // Open/close toggle — driven only by is-filterOpen on `list`
  if (filterToggle) {
    filterToggle.addEventListener("click", function () {
      setFilters(!list.classList.contains("is-filterOpen"));
    });
  }

  // Delegated close button + click-outside
  document.addEventListener("click", function (e) {
    var closeBtn = e.target.closest("[data-filter-close]");
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeFilters();
      return;
    }

    if (list.classList.contains("is-filterOpen") &&
        sidebar &&
        !sidebar.contains(e.target) &&
        !(filterToggle && filterToggle.contains(e.target))) {
      closeFilters();
    }
  });

  // Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeFilters();
  });

  // Sort dropdown
  var dropdown = list.querySelector(".ac-dropdown");

  if (dropdown) {
    var toggle = dropdown.querySelector(".ac-dropdown__toggle");
    var label = dropdown.querySelector(".ac-dropdown__label");
    var options = dropdown.querySelectorAll(".ac-dropdown__option");

    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = dropdown.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });

    options.forEach(function (option) {
      option.addEventListener("click", function () {
        options.forEach(function (item) { item.classList.remove("is-selected"); });
        option.classList.add("is-selected");
        label.textContent = option.textContent.trim();
        dropdown.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });

    document.addEventListener("click", function (e) {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  // Scroll inside filter list (Locomotive Scroll)
  var scrollAreas = document.querySelectorAll(".ac-checkList");

  scrollAreas.forEach(function (area) {
    area.addEventListener("wheel", function (e) {
      area.scrollTop += e.deltaY;
      e.preventDefault();
      e.stopPropagation();
    }, { passive: false });

    area.addEventListener("touchmove", function (e) {
      e.stopPropagation();
    }, { passive: true });
  });
});

// login modal
var acModalConfig = {
  openClass: "is-open",
  disableScroll: true,
};

MicroModal.init(acModalConfig);

// switch between the login and signup modals
document.addEventListener("click", function (e) {
  var switcher = e.target.closest("[data-modal-switch]");
  if (!switcher) return;
  e.preventDefault();

  var target = switcher.getAttribute("data-modal-switch");
  var current = switcher.closest(".ac-login");

  if (current) MicroModal.close(current.id);
  MicroModal.show(target, acModalConfig);
});
document.querySelectorAll(".ac-login__close").forEach(btn => {
  btn.addEventListener("click", function () {
    const modal = this.closest(".ac-login");
    MicroModal.close(modal.id);
  });
});